<template>
  <div>
    <v-container>
      <v-row class="mb-4">
        <h2>Introductory Information</h2>
      </v-row>
      <v-row class="mb-4">
        This lab report must be written <u class="ml-1"><b>individually</b></u
        >.
      </v-row>
      <v-simple-table>
        <thead>
          <tr v-for="field in fields1" :key="field.inputKey">
            <td style="width: 220px">
              {{ field.name }}
            </td>
            <td>
              <v-text-field v-model="inputs[field.inputKey]" />
            </td>
          </tr>
          <tr v-for="field in fields2" :key="field.inputKey">
            <td style="width: 220px">
              {{ field.name }}
            </td>
            <td>
              <v-text-field v-model="inputs[field.inputKey]" />
            </td>
          </tr>
        </thead>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'uOttawa1321IntroductionLab5',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        title: null,
        author: null,
        demonstrator: null,
        date: null,
      },
      fields1: [
        {name: 'Experiment Title: ', inputKey: 'title'},
        {name: "Author's Name: ", inputKey: 'author'},
      ],
      fields2: [
        {name: "TA's (Demonstrator's) Name: ", inputKey: 'demonstrator'},
        {name: 'Date Experiment Performed: ', inputKey: 'date'},
      ],
    };
  },
};
</script>

<style scoped></style>
